export default function ScheduleTennis() {
  console.log("schedule", HQ.Properties.schedule);
}
